module.exports = __webpack_public_path__ + "static/HeroScreensGIF_10thJune-bac556e65cd6723dde0af61ac3234bbe.gif";